// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7755 ? "3b7abc47" : chunkId) + "." + {"4654":"25768ab7497ecbc6","7755":"4a98498aa56ef6f3","9722":"9f2d71b2ec8d3ccd"}[chunkId] + ".js";
};